export default __webpack_public_path__ + "static/media/bukkit.98d1d09f.svg";